import { notification } from 'antd';
import moment from 'moment';
import DataService from 'services/data/DataService';
import ShopifyService from 'services/providers/ShopifyService';
import { getLogger } from 'utils/logging';
import DateArrays from "../../utils/DateArrays";
import IDataProvider from "./IDataProvider";

const { log, warn } = getLogger('ShopifyDataProvider', { color: 'BGgreen', enabled: false });

const DISABLE_LOCAL_DATA = true;

class ShopifyDataProvider implements IDataProvider {

    private accountId: string;

    constructor() {
        this.init();
    }

    public init = async () => {
        await DataService.removeDataSource('shopify-revenue');
    }

    public updateData = async (user, updateCallback?, completeCallback?) => {

        // temp for dev
        if (DISABLE_LOCAL_DATA || process.env.NODE_ENV == 'local') {
            log(`Shopify local provider data disabled.`)
            if (completeCallback) {
                completeCallback();
            }
            return;
        }

        this.accountId = user.activeAccount._id;
        let shopifyAccount = user.activeAccount.providers.find(p => p.name == 'Shopify');

        if (!shopifyAccount) {
            log('Clearing shopify revenue data.')
            await ShopifyService.clearRevenueData();
            DataService.removeDataSource('shopify-revenue');
            // throw new Error("User does not have an active Shopify account. ShopifyDataProvider cannot proceed.");
            return;
        } else {
            log('Shopify account:', shopifyAccount)
        }

        // Detect if a user just linked their Shopify account
        // If so, set an extra progressMessage to let the user know that it can take a long time the first time
        let progressMessage = '';
        if (moment().diff(moment(shopifyAccount.dateLinked), 'days') === 0) {
            progressMessage = 'Please note that it can take up to 30 minutes to process your Shopify data for the very first time. Feel free to explore other tabs while you wait!';
        }

        // Call the ShopifyService to pull revenue data
        ShopifyService.getRevenueData(
            this.accountId,

            // Pass in the dateArrays relevant to MER
            // (ShopifyService will use these to aggregate all required days pull missing days)
            [
                { name: 'last7d', days: DateArrays.last7Days() },
                { name: 'last30d', days: DateArrays.last30Days() },
                { name: 'mtd', days: DateArrays.mtd() },
                { name: 'qtd', days: DateArrays.qtd() },
                { name: 'ytd', days: DateArrays.ytd() },
            ],

            // callback for results
            async (days) => {
                log("Saving new Shopify revenue data source", days);
                await DataService.saveDataSource(`shopify-revenue`, days);
            },

            updateCallback,

            progressMessage

        )
            .catch(async e => {
                log('Shopify Error:', e);
                let error = 'There was an error retrieving your MER data.';
                if (e && e.status && e.status === 401) {
                    error = e.data;
                    NotificationService.notifyError('Shopify Error', error);
                }
                await DataService.saveDataSource('shopify-revenue', { error });
            });

    }

}

export default new ShopifyDataProvider();